import React, { useRef, useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import SignatureCanvas from "react-signature-canvas";
import {
  Container,
  TextField,
  MenuItem,
  Button,
  Grid,
  Typography,
  Paper,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  RadioGroup,
  Radio,
  Chip,
  IconButton,
  Box,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  ListSubheader,
  FormHelperText
} from "@mui/material";
import ShareIcon from '@mui/icons-material/Share';
import LocalHospital from '@mui/icons-material/LocalHospital';
import DraftSaveButton from '../../components/DraftSaveButton';
import { DRAFT_KEYS, hasDraft, loadDraft } from '../../utils/draftUtils';

import theme from '../../theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import { useNotification } from '../../contexts/NotificationContext';
import { API_BASE_URL } from "../../lib/constants";
const PostOperativeForm = () => {
  const { showNotification } = useNotification();
  const navigate = useNavigate();
  const { uhid_no } = useParams();

  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case 'ward_no':
        if (!value) error = "Ward No is required";
        break;
      case 'room_no':
        if (!value) error = "Room No is required";
        break;
      case 'instruction_date':
        if (!value) error = "Instruction Date is required";
        break;
      case 'surgery_done':
        if (!value) error = "Surgery Done is required";
        break;
      case 'anaesthesiologist':
        if (!value) error = "Anaesthesiologist is required";
        break;
      case 'anaesthesia':
        if (!value) error = "Anaesthesia is required";
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
    return error === "";
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    validateField(name, value);
  };
  const [formData, setFormData] = useState({
    ip_no: "",
    uhid_no: uhid_no || "",
    pt_name: "",
    age: "",
    sex: "",
    ward_no: "",
    room_no: "",
    instruction_date: "",
    postoperative_day: "",
    surgery_done: "",
    anaesthesiologist: "",
    anaesthesia: "",
    position_of_patient: "",
    nil_per_oral: "",
    iv_fluids_advised: "",
    o2: "",
    oral_liquids: "",
    diet: "",
    motor_sensory_regression: "",
    antibiotic_advised: "",
    inj_pan_40mg_iv: "",
    tablet_pan_20_40mg: "",
    inj_emeset_4mg_slow_iv: "",
    inj_paracetamol_1gm_iv: "",
    inj_paracetamol_time: "",
    inj_paracetamol_days: "",
    inj_ukat: "",
    inj_ukat_time: "",
    inj_ukat_days: "",
    epidural_infusion: "",
    concentration: "",
    concentration_text: "",
    concentration_date_time: "",
    pain_analgesia_prescribed: "",
    pain_score: "",
    analgesia_prescribed: "",
    t_alprax_hs: "",
    t_alprax_dose: "",
    other_medications: "",
    cbg_insulin_orders: "",
    blood_investigations_details: "",
    blood_investigation_date: "",
    blood_investigation_time: "",
    blood_transfusion_plan: "",
    physiotherapy: "",
    opinion_or_review: "",
    queries_to_surgeon: "",
    intake_output: "",
    anaesthesiologist_signature_blob: "",
    anaesthesiologist_name: "",
    post_op_nurse_name_id: ""
  });

  // Auto-load draft if present on mount
  useEffect(() => {
    if (uhid_no && hasDraft(DRAFT_KEYS.POST_OPERATIVE_INSTRUCTIONS, uhid_no)) {
      const saved = loadDraft(DRAFT_KEYS.POST_OPERATIVE_INSTRUCTIONS, uhid_no);
      if (saved && saved.formData) {
        setFormData(prev => ({ ...prev, ...saved.formData }));
      }
    }
  }, [uhid_no]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };
  const fetchPatientData = async (uhidNo) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/get_patient/${uhidNo}`);

      console.log(response.data);
      setFormData(prev => ({
        ...prev,

        pt_name: response.data.name,
        age: response.data.age,
        sex: response.data.sex



      }));
      setLoading(false);
    } catch (error) {
      console.error('Error fetching patient data:', error);
      setError('Failed to fetch patient data. Please try again.');
      setLoading(false);
    }
  };
  const validate = () => {
    const requiredFields = [
      { key: 'ward_no',          label: 'Ward No.'          },
      { key: 'room_no',          label: 'Room No.'          },
      { key: 'instruction_date', label: 'Instruction Date'  },
      { key: 'surgery_done',     label: 'Surgery Done'      },
      { key: 'anaesthesiologist',label: 'Anaesthesiologist' },
      { key: 'anaesthesia',      label: 'Anaesthesia Type'  },
    ];
    const tempErrors = {};
    requiredFields.forEach(({ key, label }) => {
      if (!formData[key] || String(formData[key]).trim() === '')
        tempErrors[key] = `${label} is required`;
    });
    setErrors(tempErrors);
    if (Object.keys(tempErrors).length > 0) {
      const firstKey = Object.keys(tempErrors)[0];
      const el = document.querySelector(`[name="${firstKey}"]`);
      if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.focus(); }
      showNotification('error', requiredFields.filter(f => tempErrors[f.key]).map(f => f.label));
    }
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    // Format helper for MySQL datetime (YYYY-MM-DD HH:MM:SS)
    const formatDateTime = (input) => {
      const date = new Date(input);
      if (isNaN(date)) return null;
      return date.toISOString().slice(0, 19).replace("T", " ");
    };

    // Format helper for MySQL date (YYYY-MM-DD)
    const formatDate = (input) => {
      const date = new Date(input);
      if (isNaN(date)) return null;
      return date.toISOString().slice(0, 10);
    };

    // Format helper for time (HH:MM:SS)
    const formatTime = (input) => {
      if (!input) return null;
      const date = new Date(`1970-01-01T${input}`);
      return isNaN(date) ? null : date.toTimeString().slice(0, 8);
    };

    const dataToSend = {
      ...formData,

      // Correctly format dates/times
      instruction_date: formatDate(formData.instruction_date),
      blood_investigation_date: formatDate(formData.blood_investigation_date),
      blood_investigation_time: formatTime(formData.blood_investigation_time),
      concentration_date_time: formatDateTime(formData.concentration_date_time),

      // Ensure `motor_sensory_regression` is sent as a string if it's descriptive text, not datetime
      motor_sensory_regression:
        typeof formData.motor_sensory_regression === "string"
          ? formData.motor_sensory_regression
          : "",

      // If you have other fields needing this kind of formatting, continue here...
    };
    console.log(dataToSend)
    try {
      if (success) {
        await axios.put(`${API_BASE_URL}/update_post_op_instruction/${uhid_no}`, dataToSend);
        showNotification('success', "Post-operative Instructions Form updated successfully!");
      } else {
        await axios.post(`${API_BASE_URL}/post_op_instructions`, dataToSend);
        showNotification('success', "Post-operative Instructions Form submitted successfully!");
      }
      clearSavedData();
      navigate(`/mainPage/${formData.uhid_no}`, {
        state: { from: 'PostOperativePhase', status: 'success', step: 3 },
      });
    } catch (error) {
      console.error("Error submitting the form!", error);
      showNotification('error', "Error in submitting Post-operative Instructions form!");
    }
  };

  const [signatureDialogOpen, setSignatureDialogOpen] = useState(false);
  const [currentSignatureRole, setCurrentSignatureRole] = useState("");
  const signaturePadRef = useRef(null);

  const handleSignatureOpen = (role) => {
    setCurrentSignatureRole(role);
    setSignatureDialogOpen(true);
  };

  const handleSignatureClear = () => {
    signaturePadRef.current.clear();
  };

  const handleSignatureSave = () => {
    const dataURL = signaturePadRef.current.toDataURL();
    setFormData((prevData) => ({
      ...prevData,
      [currentSignatureRole]: dataURL.split(",")[1],
    }));
    setSignatureDialogOpen(false);
  };
  const handleSignatureClose = () => {
    setSignatureDialogOpen(false)
  }
  useEffect(() => {
    if (!uhid_no) return;

    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/get_post_op_instruction/${uhid_no}`);
        const backendData = response.data;

        if (backendData && Object.keys(backendData).length > 0) {
          let formattedData = { ...backendData };

          try {
            if (backendData.instruction_date) {
              const date = new Date(backendData.instruction_date);
              if (!isNaN(date.getTime())) {
                formattedData.instruction_date = date.toISOString().slice(0, 10);
              } else {
                formattedData.instruction_date = "";
              }
            }
          } catch (dateError) {
            console.error("Error formatting instruction_date:", dateError);
            formattedData.instruction_date = "";
          }

          try {
            if (backendData.blood_investigation_date) {
              const date = new Date(backendData.blood_investigation_date);
              if (!isNaN(date.getTime())) {
                formattedData.blood_investigation_date = date.toISOString().slice(0, 10);
              } else {
                formattedData.blood_investigation_date = "";
              }
            }
          } catch (dateError) {
            console.error("Error formatting blood_investigation_date:", dateError);
            formattedData.blood_investigation_date = "";
          }

          try {
            if (backendData.motor_sensory_regression) {
              const date = new Date(backendData.motor_sensory_regression);
              if (!isNaN(date.getTime())) {
                formattedData.motor_sensory_regression = date.toISOString().slice(0, 16);
              } else {
                formattedData.motor_sensory_regression = "";
              }
            }
          } catch (dateError) {
            console.error("Error formatting motor_sensory_regression:", dateError);
            formattedData.motor_sensory_regression = "";
          }

          try {
            if (backendData.blood_investigation_time) {
              formattedData.blood_investigation_time = backendData.blood_investigation_time.slice(0, 16);
            }
          } catch (timeError) {
            console.error("Error formatting blood_investigation_time:", timeError);
            formattedData.blood_investigation_time = "";
          }

          try {
            if (backendData.concentration_date_time) {
              const date = new Date(backendData.concentration_date_time);
              if (!isNaN(date.getTime())) {
                formattedData.concentration_date_time = date.toISOString().slice(0, 16);
              } else {
                formattedData.concentration_date_time = "";
              }
            }
          } catch (dateError) {
            console.error("Error formatting concentration_date_time:", dateError);
            formattedData.concentration_date_time = "";
          }

          setFormData((prevData) => ({
            ...prevData,
            ...formattedData,
          }));

          setSuccess(true);
        } else {
          setFormData((prevData) => ({
            ...prevData,
            uhid_no: uhid_no,
          }));
          setSuccess(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to fetch post-operative data. Proceeding with empty form.");
        setSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    fetchPatientData(uhid_no);
  }, [uhid_no]);

  // Fetch next UHID & IP_No on component mount
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [ipRes] = await Promise.all([

          axios.get(`${API_BASE_URL}/postop_instruct_next_ip`)
        ]);
        setFormData(prev => ({
          ...prev,

          ip_no: ipRes.data.next_ip
        }));
      } catch (error) {
        console.error('Failed to fetch initial data:', error);
      }
    };

    fetchInitialData();
  }, []);
  const roomOptions = ['101', '102', '103', '201', '202'];
  const nilPerOralOptions = [
    "8 hours", "6 hours", "4 hours", "Overnight fasting"
  ];
  const wardOptions = ['Ward 1', 'Ward 2', 'Ward 3', 'ICU', 'General', 'Private'];
  const ivFluidsOptions = [
    "Normal Saline", "Ringer's Lactate", "Dextrose", "5% Dextrose", "DNS", "D5NS"
  ];
  const surgeryOptions = [
    "Appendectomy", "Cholecystectomy", "Hernia Repair", "C-Section", "Orthopedic Surgery"
  ];
  const anaesthesiaOptions = [
    "General Anaesthesia", "Spinal Anaesthesia", "Local Anaesthesia", "Epidural", "Sedation"
  ];
  const positionOptions = [
    "Supine", "Prone", "Lateral", "Lithotomy", "Trendelenburg"
  ];
  const oralLiquidsOptions = [
    "Water",
    "ORS (Oral Rehydration Solution)",
    "Juice",
    "Coconut Water",
    "Clear Broth",
    "Tea",
    "Milk",
  ];
  const antibioticOptions = [
    'Amoxicillin',
    'Ciprofloxacin',
    'Azithromycin',
    'Ceftriaxone',
    'Metronidazole',
    'Doxycycline',
    'Clindamycin',
  ];
  const paracetamolOptions = [
    'Given',
    'Not Given',
    '8 Hourly',
    '6 Hourly',
    '12 Hourly',
    'As Required',
  ];
  const injUketOptions = [
    'B.D',
    'SOS',
    'Once Daily',
    'Twice Daily',
    'Thrice Daily',
    'As Required',
  ];
  const epiduralConcentrationOptions = [
    '0.0625%',
    '0.1%',
    '0.125%',
    '0.2%',
    '0.25%',
    '0.5%',
  ];
  const concentrationOptions = [
    '0.0625%',
    '0.1%',
    '0.125%',
    '0.2%',
    '0.25%',
    '0.5%',
  ];
  const painAnalgesiaOptions = [
    'Paracetamol',
    'NSAIDs',
    'Morphine',
    'Fentanyl',
    'Tramadol',
    'Other',
  ];
  const doctorGroups = {
    Cardiologists: [
      "Dr. John Smith",
      "Dr. Emily Johnson",
      "Dr. Michael Brown",
      "Dr. Sarah Davis",
      "Dr. William Wilson",
      "Dr. Linda Martinez"
    ],
    Neurologists: [
      "Dr. Robert Lee",
      "Dr. Patricia Taylor",
      "Dr. James Anderson",
      "Dr. Barbara Thomas",
      "Dr. David Jackson",
      "Dr. Susan White"
    ],
    Orthopedics: [
      "Dr. Richard Garcia",
      "Dr. Jennifer Harris",
      "Dr. Charles Clark",
      "Dr. Jessica Lewis",
      "Dr. Thomas Robinson",
      "Dr. Karen Walker"
    ],
    Dermatologists: [
      "Dr. Nancy Young",
      "Dr. Matthew Hall",
      "Dr. Donna Allen",
      "Dr. Steven King",
      "Dr. Michelle Wright",
      "Dr. George Scott"
    ],
    Gynecologists: [
      "Dr. Sandra Green",
      "Dr. Kevin Adams",
      "Dr. Laura Baker",
      "Dr. Mark Nelson",
      "Dr. Angela Carter",
      "Dr. Brian Mitchell"
    ],
    Pediatricians: [
      "Dr. Melissa Perez",
      "Dr. Eric Roberts",
      "Dr. Deborah Turner",
      "Dr. Jason Phillips",
      "Dr. Rebecca Campbell",
      "Dr. Andrew Parker"
    ],
    AnaesthesiaSpecialists: [
      "Dr. Anil Mehta",
      "Dr. Priya Iyer",
      "Dr. Rakesh Nair",
      "Dr. Neha Sharma",
      "Dr. Vivek Rao",
      "Dr. Aarti Desai"
    ]
  };
  const medicationOptions = [
    "Paracetamol 500mg",
    "Ibuprofen 400mg",
    "Metformin",
    "Aspirin",
    "Lisinopril",
    "Other medication",
  ];

  const insulinOrderOptions = [
    "Rapid-acting insulin",
    "Long-acting insulin",
    "Sliding scale insulin",
    "Insulin pump",
    "Other insulin orders",
  ];
  const bloodTransfusionOptions = [
    'No transfusion needed',
    'Type and Crossmatch done',
    'Packed Red Blood Cells',
    'Fresh Frozen Plasma',
    'Platelets',
    'Cryoprecipitate',
    'Other',
  ];
  const painScoreOptions = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
  const opinionOptions = [
    'No additional opinion needed',
    'Consult cardiology',
    'Consult pulmonology',
    'Further imaging required',
    'Repeat lab tests',
  ];

  const queriesOptions = [
    'Clarify medication doses',
    'Discuss postoperative care',
    'Ask about follow-up schedule',
    'Discuss possible complications',
  ];

  const intakeOutputOptions = [
    'Monitor hourly',
    'Record every 4 hours',
    'IV fluids ongoing',
    'Oral intake resumed',
    'Strict input/output charting',
  ];
  const nurseOptions = [
    'Nurse John Doe - ID 123',
    'Nurse Jane Smith - ID 456',
    'Nurse Emily Johnson - ID 789',

  ];
  const bloodInvestigationOptions = [
    "Complete Blood Count (CBC)",
    "Blood Sugar",
    "Liver Function Test",
    "Kidney Function Test",
    "Coagulation Profile",
    "Electrolytes",
    // Add more as needed
  ];

  const handleNameChange = (e) => {
    const regex = /^[a-zA-Z\s.-]*$/; // allow letters, spaces, dot, hyphen
    const value = e.target.value;
    if (value === '' || regex.test(value)) {
      setFormData({ ...formData, [e.target.name]: value });
      if (errors[e.target.name]) {
        setErrors((prev) => ({ ...prev, [e.target.name]: '' }));
      }
    }
  };
  const goToVideoRecorder = (formName, uhid_no) => {
    navigate(`/video?form=${encodeURIComponent(formName)}&uhid_no=${encodeURIComponent(uhid_no)}`);
  };
  const [submitStatus, setSubmitStatus] = useState({
    open: false,
    message: "",
    severity: "success"
  });
  const [savedData, setSavedData] = useState(null);
  const [showSaveNotification, setShowSaveNotification] = useState(false);
  const [currentPage, setCurrentPage] = useState('form');
  const [dataLoaded, setDataLoaded] = useState(false);
  // Auto-save functionality
  // Auto-save functionality - only after initial data is loaded
  useEffect(() => {
    if (!dataLoaded) return; // Don't auto-save until initial data is loaded

    const timeoutId = setTimeout(() => {
      if (hasFormData()) {
        saveFormData(formData);
        setShowSaveNotification(true);
        setTimeout(() => setShowSaveNotification(false), 2000);
      }
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [formData, dataLoaded]);

  // Save form data to sessionStorage
  const saveFormData = (data) => {
    sessionStorage.setItem(`post_opertive_instructionForm_${uhid_no}`, JSON.stringify(data));
    console.log('Form data saved:', data);
  };

  // Get saved form data
  const getSavedFormData = () => {
    const saved = sessionStorage.getItem(`post_opertive_instructionForm_${uhid_no}`);
    return saved ? JSON.parse(saved) : null;
  };
  useEffect(() => {
    const saved = getSavedFormData();
    if (saved && Object.keys(saved).length > 0) {
      setSavedData(saved);
      setFormData(saved);
    }
  }, []);
  // Check if form has any data
  const hasFormData = () => {
    return Object.values(formData).some(value => {
      if (typeof value === 'string') return value.trim() !== '';
      if (typeof value === 'object' && value !== null) {
        return Object.values(value).some(subValue =>
          typeof subValue === 'string' ? subValue.trim() !== '' : subValue
        );
      }
      return value === true;
    });
  };

  // Clear saved data - ONLY called on successful submit
  const clearSavedData = () => {
    setSavedData(null);
    sessionStorage.removeItem(`post_opertive_instructionForm_${uhid_no}`);
    sessionStorage.removeItem(`formStatus_post_opertive_instruction_${uhid_no}`);
  };

  // Home button handler
  const handleHomeNavigation = () => {
    if (hasFormData()) {
      saveFormData(formData);
      // Store form status for home page to show "Continue" button
      sessionStorage.setItem(`formStatus_post_opertive_instruction_${uhid_no}`, JSON.stringify({
        formName: 'CONSENT FOR HIGH RISK',
        uhid_no: uhid_no,
        status: 'incomplete',
        lastSaved: new Date().toISOString(),
        continueUrl: `/highRiskConsentForm/${uhid_no}`
      }));
    }
    navigate('/home');
  };
  const handleBack = () => {
    navigate(`/mainPage/${formData.uhid_no}`, {
      state: { from: 'PostOperativePhase', status: 'success', step: 3 },
    }); // Navigate to the previous page
  };
  const handleShareClick = async () => {
    try {
      // Call API to generate a share token for the given UHID
      const res = await axios.post(`${API_BASE_URL}/generate_for_post_op_instruct_share_token/${uhid_no}`);

      const token = res.data.token;
      const link = `${API_BASE_URL}/postOperativeForm2/${uhid_no}?token=${token}`;
      const message = `Dear Doctor,\n\nPlease fill the post-operative analgesia chart:\n\n${link}`;

      // Copy the shareable link to clipboard
      await navigator.clipboard.writeText(link);

      // Show success notification to user
      setSubmitStatus({
        open: true,
        message: "Secure link copied to clipboard!",
        severity: "info",
      });

      // Open WhatsApp chat with pre-filled message (replace phone number if needed)
      const phoneNumber = '+916379605575'; // no spaces or special chars for wa.me
      window.open(`http://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
    } catch (error) {
      console.error("Error generating share token:", error);

      // Show error notification to user
      setSubmitStatus({
        open: true,
        message: "Failed to generate shareable link",
        severity: "error",
      });
    }
  };
  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
        <Paper elevation={3} sx={{ padding: 3 }}>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 2 }}>
            {/* Heading with Icon */}
            <Typography
              variant="h4"
              sx={{
                color: '#008080',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 600,
                letterSpacing: 0.5,
              }}
            >

              POST OPERATIVE INSTRUCTIONS
            </Typography>

            {/* Right-aligned Logo and Text */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <img src="/logo.png" alt="Logo" className="w-8 h-8" />
              <Typography
                variant="h6"
                sx={{
                  color: '#008080',
                  marginLeft: 1,
                  fontWeight: 500,
                  letterSpacing: 0.3,
                }}
              >
                OTMS
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
            {/* Left-aligned Back Button */}
            <Button
              variant="outlined"
              onClick={handleBack}
              sx={{ marginLeft: 2 }}
            >
              Back
            </Button>

            {/* Right-aligned Buttons */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant="contained"
                onClick={handleHomeNavigation}
                sx={{ marginRight: 1 }}
              >
                Home
              </Button>
              <Button
                variant="contained"
                onClick={() => goToVideoRecorder("POST OPERATIVE INSTRUCTIONS", uhid_no)}
                sx={{ marginRight: 1 }}
              >
                Add Iterative Video
              </Button>
              <IconButton color="primary" aria-label="share" onClick={handleShareClick}>
                <ShareIcon />
              </IconButton>
            </Box>
          </Box>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Patient Name"
                  onChange={handleNameChange}
                  name="pt_name"
                  value={formData.pt_name}
                  InputProps={{ readOnly: true, }}
                  required
                  fullWidth

                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Age"
                  type="number"
                  onChange={handleChange}
                  name="age"
                  value={formData.age}
                  InputProps={{ readOnly: true, }}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField select label="Gender" name="sex" InputProps={{ readOnly: true, }} required fullWidth onChange={handleChange} value={formData.sex}>
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="UHID No"
                  type="number"
                  onChange={handleChange}
                  value={formData.uhid_no}
                  name="uhid_no"
                  required
                  fullWidth
                  InputProps={{ readOnly: true, }}

                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label=" IP No"
                  type="number"
                  onChange={handleChange}
                  value={formData.ip_no}
                  name="ip_no"
                  required
                  fullWidth
                  InputProps={{ readOnly: true, }}

                />
              </Grid>
              <Grid item xs={6} sm={6}>
                <FormControl fullWidth variant="outlined" required error={!!errors.ward_no}>
                  <InputLabel id="ward-label">Ward No</InputLabel>
                  <Select
                    labelId="ward-label"
                    id="ward-select"
                    name="ward_no"
                    value={formData.ward_no}
                    onChange={(e) => {
                      setFormData({ ...formData, ward_no: e.target.value });
                      if (errors.ward_no) setErrors(prev => ({ ...prev, ward_no: "" }));
                    }}
                    onBlur={handleBlur}
                    label="Ward No"
                  >
                    {wardOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.ward_no && <FormHelperText>{errors.ward_no}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6}>
                <FormControl fullWidth variant="outlined" required error={!!errors.room_no}>
                  <InputLabel id="room-label">Room No</InputLabel>
                  <Select
                    labelId="room-label"
                    id="room-select"
                    name="room_no"
                    value={formData.room_no}
                    onChange={(e) => {
                      setFormData({ ...formData, room_no: e.target.value });
                      if (errors.room_no) setErrors(prev => ({ ...prev, room_no: "" }));
                    }}
                    onBlur={handleBlur}
                    label="Room No"
                  >
                    {roomOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.room_no && <FormHelperText>{errors.room_no}</FormHelperText>}
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={6}>
                <TextField
                  label="Instruction Date"
                  type="date"
                  name="instruction_date"
                  value={formData.instruction_date}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  error={!!errors.instruction_date}
                  helperText={errors.instruction_date}
                  inputProps={{
                    min: new Date().toISOString().split("T")[0],
                  }}
                />
              </Grid>
            </Grid>
            <Divider sx={{ my: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Postoperative Day"
                  type="number"
                  onChange={handleChange}
                  value={formData.postoperative_day}
                  name="postoperative_day"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  freeSolo
                  options={surgeryOptions}
                  value={formData.surgery_done}
                  onInputChange={(event, newInputValue) => {
                    setFormData({ ...formData, surgery_done: newInputValue });
                    if (errors.surgery_done) setErrors(prev => ({ ...prev, surgery_done: "" }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Surgery Done"
                      name="surgery_done"
                      required
                      fullWidth
                      error={!!errors.surgery_done}
                      helperText={errors.surgery_done}
                      onBlur={handleBlur}
                    />
                  )}
                />
              </Grid>
              <FormControl fullWidth required variant="outlined" sx={{ marginTop: 1 }} error={!!errors.anaesthesiologist}>
                <InputLabel id="anaesthesiologist-label">Anaesthesiologist</InputLabel>
                <Select
                  labelId="anaesthesiologist-label"
                  name="anaesthesiologist"
                  value={formData.anaesthesiologist}
                  onChange={(e) => {
                    setFormData({ ...formData, anaesthesiologist: e.target.value });
                    if (errors.anaesthesiologist) setErrors(prev => ({ ...prev, anaesthesiologist: "" }));
                  }}
                  onBlur={handleBlur}
                  label="Anaesthesiologist"
                >
                  {doctorGroups["AnaesthesiaSpecialists"].map((doctor, idx) => (
                    <MenuItem key={`AnaesthesiaSpecialists-${idx}`} value={doctor}>
                      {doctor}
                    </MenuItem>
                  ))}
                </Select>
                {errors.anaesthesiologist && <FormHelperText>{errors.anaesthesiologist}</FormHelperText>}
              </FormControl>
              <Grid item xs={12} sm={6} >
                <Autocomplete
                  freeSolo
                  options={anaesthesiaOptions}
                  value={formData.anaesthesia}
                  onInputChange={(event, newInputValue) => {
                    setFormData({ ...formData, anaesthesia: newInputValue });
                    if (errors.anaesthesia) setErrors(prev => ({ ...prev, anaesthesia: "" }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Anaesthesia"
                      name="anaesthesia"
                      required
                      fullWidth
                      error={!!errors.anaesthesia}
                      helperText={errors.anaesthesia}
                      onBlur={handleBlur}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={positionOptions}
                  value={formData.position_of_patient}
                  onInputChange={(event, newInputValue) =>
                    setFormData({ ...formData, position_of_patient: newInputValue })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Position of Patient"
                      name="position_of_patient"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={nilPerOralOptions}
                  value={formData.nil_per_oral}
                  onInputChange={(event, newInputValue) => {
                    setFormData({ ...formData, nil_per_oral: newInputValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Nil per Oral"
                      name="nil_per_oral"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={ivFluidsOptions}
                  value={formData.iv_fluids_advised}
                  onInputChange={(event, newInputValue) => {
                    setFormData({ ...formData, iv_fluids_advised: newInputValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="IV Fluids Advised"
                      name="iv_fluids_advised"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  select
                  label="O2"
                  value={formData.o2}
                  onChange={handleChange}
                  name="o2"
                  required
                  fullWidth
                >
                  <MenuItem value="Mask">Mask</MenuItem>
                  <MenuItem value="Prongs">Prongs</MenuItem>
                  <MenuItem value="NIV">NIV</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={oralLiquidsOptions}
                  value={formData.oral_liquids}
                  onInputChange={(event, newInputValue) =>
                    setFormData({ ...formData, oral_liquids: newInputValue })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Oral Liquids"
                      name="oral_liquids"
                      fullWidth
                      multiline
                      rows={3}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  select
                  label="Diet"
                  onChange={handleChange}
                  value={formData.diet}
                  name="diet"
                  required
                  fullWidth
                >
                  <MenuItem value="Semisolid">Semisolid</MenuItem>
                  <MenuItem value="Normal">Normal</MenuItem>
                  <MenuItem value="Diabetic">Diabetic</MenuItem>
                  <MenuItem value="High Protein Diet">High Protein Diet</MenuItem>
                  <MenuItem value="Others">Others</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Motor and Sensory Regression Date & Time"
                  type="DateTime-local" inputProps={{
                    min: new Date().toISOString().slice(0, 16), // Sets the minimum date and time to the current date and time
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={handleChange}
                  value={formData.motor_sensory_regression}
                  name="motor_sensory_regression"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={antibioticOptions}
                  value={formData.antibiotic_advised}
                  onInputChange={(event, newInputValue) =>
                    setFormData({ ...formData, antibiotic_advised: newInputValue })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Antibiotic Advised"
                      name="antibiotic_advised"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  select
                  label="Inj. Pan 40mg IV"
                  onChange={handleChange}
                  value={formData.inj_pan_40mg_iv}
                  name="inj_pan_40mg_iv"

                  required
                  fullWidth
                >
                  <MenuItem value="O.D">O.D</MenuItem>
                  <MenuItem value="B.D">B.D</MenuItem>

                </TextField>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  select
                  label="Tablet Pan 20mg /40mg"
                  onChange={handleChange}
                  value={formData.tablet_pan_20_40mg}
                  name="tablet_pan_20_40mg"

                  required
                  fullWidth
                >
                  <MenuItem value="O.D">O.D</MenuItem>
                  <MenuItem value="B.D">B.D</MenuItem>

                </TextField>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  select
                  label="Inj. Emeset 4 mg Slow IV"
                  onChange={handleChange}
                  value={formData.inj_emeset_4mg_slow_iv}
                  name="inj_emeset_4mg_slow_iv"

                  required
                  fullWidth
                >
                  <MenuItem value="SOS">SOS</MenuItem>
                  <MenuItem value="O.D">O.D</MenuItem>
                  <MenuItem value="B.D">B.D</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <Autocomplete
                  freeSolo
                  options={paracetamolOptions}
                  value={formData.inj_paracetamol_1gm_iv || ''}
                  onInputChange={(event, newInputValue) =>
                    setFormData({ ...formData, inj_paracetamol_1gm_iv: newInputValue })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Inj. Paracetamol 1gm IV Infusion 8° Hourly"
                      name="inj_paracetamol_1gm_iv"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Time"
                  type="time"
                  InputLabelProps={{ shrink: true }}
                  onChange={handleChange}
                  value={formData.inj_paracetamol_time}
                  name="inj_paracetamol_time"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Day"
                  type="number"
                  onChange={handleChange}
                  value={formData.inj_paracetamol_days}
                  name="inj_paracetamol_days"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <Autocomplete
                  freeSolo
                  options={injUketOptions}
                  value={formData.inj_ukat || ''}
                  onInputChange={(event, newInputValue) =>
                    setFormData({ ...formData, inj_ukat: newInputValue })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Inj. Uket 1 ampule in 100 ml NS over 20 to 30 minutes (B.D or SOS)"
                      name="inj_ukat"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Time"
                  type="time"
                  InputLabelProps={{ shrink: true }}
                  onChange={handleChange}
                  value={formData.inj_ukat_time}
                  name="inj_ukat_time"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Day"
                  type="number"
                  onChange={handleChange}
                  value={formData.inj_ukat_days}
                  name="inj_ukat_days"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <Autocomplete
                  freeSolo
                  options={epiduralConcentrationOptions}
                  value={formData.epidural_infusion || ''}
                  onInputChange={(event, newInputValue) =>
                    setFormData({ ...formData, epidural_infusion: newInputValue })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Epidural infusion: Concentration"
                      name="epidural_infusion"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  select
                  label="Concentration"
                  onChange={handleChange}
                  value={formData.concentration}
                  name="concentration"
                  required
                  fullWidth
                >
                  <MenuItem value="ML">ML</MenuItem>
                  <MenuItem value="HR">HR</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <Autocomplete
                  freeSolo
                  options={concentrationOptions}
                  value={formData.concentration_text || ''}
                  onInputChange={(event, newInputValue) => {
                    setFormData({ ...formData, concentration_text: newInputValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Concentration:"
                      name="concentration_text"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="On Time Till / Date of Time:"
                  type="DateTime-local" inputProps={{
                    min: new Date().toISOString().slice(0, 16), // Sets the minimum date and time to the current date and time
                  }}
                  InputLabelProps={{ shrink: true }}
                  onChange={handleChange}
                  value={formData.concentration_date_time}
                  name="concentration_date_time"
                  required
                  fullWidth

                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={painAnalgesiaOptions}
                  value={formData.pain_analgesia_prescribed || ''}
                  onInputChange={(event, newInputValue) => {
                    setFormData({ ...formData, pain_analgesia_prescribed: newInputValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="For Breakthrough Pain Analgesia Prescribed"
                      name="pain_analgesia_prescribed"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={painScoreOptions}
                  value={formData.pain_score?.toString() || ''}
                  onInputChange={(event, newInputValue) => {
                    setFormData({ ...formData, pain_score: newInputValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Pain Score > 4-5/10"
                      name="pain_score"
                      fullWidth
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>

                <TextField
                  select
                  label="T. Alprax H.S"
                  onChange={handleChange}
                  value={formData.t_alprax_hs}
                  name="t_alprax_hs"

                  required
                  fullWidth

                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>

                </TextField>
                {formData.t_alprax_hs === "Yes" && (
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"

                    name="t_alprax_dose"
                    value={formData.t_alprax_dose || ''}
                    onChange={handleChange}
                  >
                    {["0.25 mg", "0.5 mg"].map((grade) => (
                      <FormControlLabel
                        key={grade}
                        control={<Radio />}
                        label={grade}
                        value={String(grade)}
                      />
                    ))}
                  </RadioGroup>

                )}
              </Grid>
            </Grid>
            <br />
            <Divider variant="middle" sx={{ mb: 2 }} />
            <Typography variant="h5" sx={{ textAlign: "center", mb: 2 }}>
              Other Routine Medication If Any to be Continued
            </Typography>

            <textarea
              style={{ width: '97%', height: '100px', border: '1px solid black', padding: '10px' }}
              onChange={handleChange}
              value={formData.other_medications}
              name="other_medications"
            />
            <Typography variant="h5" sx={{ textAlign: "center", mb: 2 }}>
              CBG and Insulin Orders
            </Typography>
            <textarea
              style={{ width: '97%', height: '100px', border: '1px solid black', padding: '10px' }}
              onChange={handleChange}
              value={formData.cbg_insulin_orders}
              name="cbg_insulin_orders"
            />
            <Divider variant="middle" sx={{ mb: 2 }} />
            <br />
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Autocomplete
                  freeSolo
                  options={bloodInvestigationOptions}
                  value={formData.blood_investigations_details || ""}
                  onInputChange={(event, newInputValue) => {
                    setFormData({ ...formData, blood_investigations_details: newInputValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Blood Investigations to be Done"
                      name="blood_investigations_details"
                      required
                      fullWidth
                    />
                  )}
                />

              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  onChange={handleChange}
                  value={formData.blood_investigation_date}
                  name="blood_investigation_date"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Time"
                  type="time"
                  InputLabelProps={{ shrink: true }}
                  onChange={handleChange}
                  value={formData.blood_investigation_time}
                  name="blood_investigation_time"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={bloodTransfusionOptions}
                  value={formData.blood_transfusion_plan || ""}
                  onInputChange={(event, newInputValue) => {
                    setFormData({ ...formData, blood_transfusion_plan: newInputValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Blood Transfusion Plan"
                      name="blood_transfusion_plan"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  select
                  label="Physiotherapy"
                  onChange={handleChange}
                  value={formData.physiotherapy}
                  name="physiotherapy"
                  required
                  fullWidth
                >
                  <MenuItem value="Limb physiotherapy">Limb physiotherapy</MenuItem>
                  <MenuItem value="Incentive Spirometry">Incentive Spirometry</MenuItem>
                  <MenuItem value="Deep Breathing Exercises">Deep Breathing Exercises</MenuItem>
                  <MenuItem value="Ambulation Plan">Ambulation Plan</MenuItem>

                </TextField>
              </ Grid>

              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={opinionOptions}
                  value={formData.opinion_or_review || ''}
                  onInputChange={(event, newInputValue) => {
                    setFormData({ ...formData, opinion_or_review: newInputValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Opinion or Review if Needed"
                      name="opinion_or_review"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={queriesOptions}
                  value={formData.queries_to_surgeon || ''}
                  onInputChange={(event, newInputValue) => {
                    setFormData({ ...formData, queries_to_surgeon: newInputValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Any Queries to be Discussed with Surgeon"
                      name="queries_to_surgeon"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  freeSolo
                  options={intakeOutputOptions}
                  value={formData.intake_output || ''}
                  onInputChange={(event, newInputValue) => {
                    setFormData({ ...formData, intake_output: newInputValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Intake / Output"
                      name="intake_output"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Divider variant="middle" sx={{ mb: 2 }} />
            <Typography variant="h6" sx={{ marginTop: 3 }}>Signatures</Typography>
            <Divider />
            <Grid container spacing={2}>
              {[{
                name: "Anaesthesiologist",
                key: "anaesthesiologist_signature_blob",
                key1: "anaesthesiologist_name",
                label: "Anaesthesiologist"
              }].map((person, index) => (
                <Grid item xs={12} key={index}>
                  <FormControl fullWidth sx={{ marginTop: 1 }}>
                    <InputLabel>{`Name (${person.label})`}</InputLabel>
                    <Select
                      name={person.key1}
                      value={formData[person.key1]}
                      onChange={handleNameChange}
                      label={`Name (${person.label})`}
                    >
                      <MenuItem value="">
                        <em>Select Doctor</em>
                      </MenuItem>
                      {doctorGroups["AnaesthesiaSpecialists"].map((doctor, idx) => (
                        <MenuItem key={`AnaesthesiaSpecialists-${idx}`} value={doctor}>
                          {doctor}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <Button variant="outlined" color="primary" sx={{ marginTop: 2 }} onClick={() => handleSignatureOpen(person.key)}> Sign Here </Button>
                  {formData[person.key] && <img src={`data:image/png;base64,${formData[person.key]}`} Base64 alt="Signature" style={{ marginTop: 10, border: '1px solid black', width: '100%', height: '150px' }} />}
                </Grid>
              ))}
            </Grid>

            <Dialog open={signatureDialogOpen} onClose={() => setSignatureDialogOpen(false)}>
              <DialogTitle>Provide Your Signature</DialogTitle>
              <DialogContent>
                <SignatureCanvas ref={signaturePadRef} canvasProps={{ width: 400, height: 200, className: 'sigCanvas' }} />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleSignatureClear} color="secondary">Clear</Button>
                <Button onClick={handleSignatureSave} >Done</Button>
                <Button onClick={handleSignatureClose} color="secondary">Close</Button>
              </DialogActions>
            </Dialog>

            <br></br>
            <Grid item xs={12} md={6} >
              <Autocomplete
                freeSolo
                options={nurseOptions}
                value={formData.post_op_nurse_name_id || ''}
                onInputChange={(event, newInputValue) => {
                  setFormData({ ...formData, post_op_nurse_name_id: newInputValue });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Post OP Nurse Name & ID No"
                    name="post_op_nurse_name_id"
                    fullWidth
                  />
                )}
              />
            </Grid>

            <DraftSaveButton
              formKey={DRAFT_KEYS.POST_OPERATIVE_INSTRUCTIONS}
              uhidNo={uhid_no}
              formData={formData}
              onDraftLoaded={(draftData) => setFormData(prev => ({ ...prev, ...draftData }))}
              variant="outlined"
              size="large"
              isUpdate={success}
            />
            <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 3 }} fullWidth onClick={handleSubmit}>
              {success ? 'Update' : 'Submit'}
            </Button>
          </form>
        </Paper>
      </Container>
    </ThemeProvider>
  );
};

export default PostOperativeForm;